// angular-cli upgrade says to remove this import. Commenting out for now.
// import './polyfills'; // <-- Moved polyfill import here. This has to be loaded before Angular

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
